import { observer } from 'mobx-react';
import * as React from 'react';
import { TvComparison } from '@teliaee/telia-common-components';
import { ICardProps, IModalProps } from 'telia-front-react';
import config from '../Config';
import { useStores } from '../stores/RootStore';

export interface TvComparisonContainerProps {
  headingText: string;
  isOpen?: boolean;
  icons?: { [key: string]: string };
  isModal?: boolean;
  shownChannelsCount?: number;
  shownThemesCount?: number;
  shownServicesCount?: number;
  shownAppsCount?: number;
  headingIsSrOnlyInDesktop?: boolean;
  card?: ICardProps;
  modal?: IModalProps;
  disableTranslationsStatistics?: boolean;
  isTestEnvironment?: boolean;
}

const TvComparisonContainer = observer((props: TvComparisonContainerProps): React.JSX.Element => {
  const {
    headingText,
    isOpen,
    icons,
    isModal,
    shownChannelsCount,
    shownThemesCount,
    shownServicesCount,
    shownAppsCount,
    headingIsSrOnlyInDesktop,
    card,
    modal,
    disableTranslationsStatistics,
    isTestEnvironment,
  } = props;
  const { languageStore } = useStores();

  return (
    <TvComparison
      isOpen={isOpen}
      icons={icons}
      tier={config.componentTier}
      language={languageStore.currentLanguage}
      isModal={isModal}
      shownChannelsCount={shownChannelsCount}
      shownThemesCount={shownThemesCount}
      shownServicesCount={shownServicesCount}
      shownAppsCount={shownAppsCount}
      headingText={headingText}
      headingIsSrOnlyInDesktop={headingIsSrOnlyInDesktop}
      card={card}
      modal={modal}
      disableTranslationsStatistics={disableTranslationsStatistics}
      isTestEnvironment={isTestEnvironment}
    />
  );
});

export default TvComparisonContainer;
